export default "__VITE_ASSET__DPvzszU$__"